import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';

@Component({
  selector: 'etxe-property-publish-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    DialogLayoutAuraComponent,
  ],
  templateUrl: './property-publish-confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyPublishConfirmationDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PropertyPublishConfirmationDialogComponent, boolean>);

  confirmed = signal<boolean>(false);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
